import { BehaviorSubject, Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { FeatureToggleClientService } from '@schwab/schwab-feature-toggle-angular';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FeatureFlagActions } from '../../feature-flags/actions';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  featureServiceReady$: Observable<boolean>;

  public featureFlags: { [key: string]: boolean; } = {
    pjlsEnabled: false,
    positionLotsPhase2Enabled: false,
    positionLotsPhase2SelectAllCheckBoxEnabled: false,
    disableDisplayL2Tabs: false,
    enableImportTransactionsUiMonolith: false,
    enableTotalDistSloaBsloaIt: false,
    enablePALCreateWireTrxn: false,
    enableAchPath: false,
    enableSpecialStateTax: false,
    enableUseSloaContainer: false,
  };

  public featureFlagSubjects: { [key: string]: BehaviorSubject<boolean>; } = { enableReactivateAchTransactions$: new BehaviorSubject<boolean>(false), };

  private readonly featureService: FeatureToggleClientService = inject(FeatureToggleClientService);
  private store: Store = inject(Store);

  initializeFeatureFlags(): Promise<void> {
    this.featureServiceReady$ = this.featureService.monitorReadiness();

    this.featureServiceReady$.pipe(
      filter((isReady: boolean) => isReady),
      take(1)
    ).subscribe((_) => {
      this.featureFlags.pjlsEnabled = this.featureService.evaluateFlag('PJLS_Phase1_Rollout', false);
      this.featureFlags.positionLotsPhase2Enabled = this.featureService.evaluateFlag('Position_Lots_Phase2_Rollout', false);
      this.featureFlags.enableImportTransactionsUiMonolith = this.featureService.evaluateFlag('enable-import-transactions-ui-monolith', false);
      this.featureFlags.enableSpecialStateTax = this.featureService.evaluateFlag('enable-special-state-tax', false);
      this.featureService
        .monitorFlag('enable-reactivate-ach-standing-authorization')
        .subscribe(this.featureFlagSubjects.enableReactivateAchTransactions$);
      this.featureService
        .monitorFlag('enable-create-sloa-toggle-for-custom-rules')
        .subscribe((flag) => this.store.dispatch(FeatureFlagActions.setFlag({
          name: 'createSloaToggleForCreateRulesEnabled',
          value: flag,
          defaultValue: false
        })));
      this.featureService
        .monitorFlag('disable-L2-tabs')
        .subscribe((flag) => this.store.dispatch(FeatureFlagActions.setFlag({
          name: 'disableDisplayL2Tabs',
          value: flag,
          defaultValue: false
        })));
      this.featureService
        .monitorFlag('enable-total-dist-sloa-bsloa-internal-transfers')
        .subscribe((flag) => this.store.dispatch(FeatureFlagActions.setFlag({
          name: 'enableTotalDistSloaBsloaIt',
          value: flag,
          defaultValue: false
        })));
      this.featureService
        .monitorFlag('enable-PAL-create-wire-trxn')
        .subscribe((flag) => this.store.dispatch(FeatureFlagActions.setFlag({
          name: 'enablePALCreateWireTrxn',
          value: flag,
          defaultValue: false
        })));
      this.featureService
        .monitorFlag('enable-recurring-checks-standing-auth')
        .subscribe((flag) => this.store.dispatch(FeatureFlagActions.setFlag({
          name: 'enableRecurringChecksStandingAuth',
          value: flag,
          defaultValue: false
        })));
      this.featureService
        .monitorFlag('enable-ach-path')
        .subscribe((flag) => this.store.dispatch(FeatureFlagActions.setFlag({
          name: 'enableAchPath',
          value: flag,
          defaultValue: false
        })));
      this.featureService
        .monitorFlag('enable-wires-condensed-layout')
        .subscribe((flag) => this.store.dispatch(FeatureFlagActions.setFlag({
          name: 'enableWiresCondensedLayout',
          value: flag,
          defaultValue: false
        })));
      this.featureService
        .monitorFlag('enable-special-state-tax')
        .subscribe((flag) => this.store.dispatch(FeatureFlagActions.setFlag({
          name: 'enableSpecialStateTax',
          value: flag,
          defaultValue: false
        })));
      this.featureService
        .monitorFlag('enable-code-y4-recurring-checks')
        .subscribe((flag) => this.store.dispatch(FeatureFlagActions.setFlag({
          name: 'enableCodeY4RecurringChecks',
          value: flag,
          defaultValue: false
        })));
      this.featureService
        .monitorFlag('enable-use-sloa-container')
        .subscribe((flag) => this.store.dispatch(FeatureFlagActions.setFlag({
          name: 'enableUseSloaContainer',
          value: flag,
          defaultValue: false
        })));
    });

    return new Promise<void>((resolve) => {
      resolve();
      return;
    });
  }
}
